import { RSAA, getJSON } from 'redux-api-middleware'

import entryPoint from '../../constants/endpoints'
import { types } from './reducer'

// Failure types are left as plain strings on purpose: the middleware then hands
// the reducer an ApiError whose `response` holds the parsed error body.
const success = (type) => ({
  type,
  payload: (action, state, res) => getJSON(res),
})

export const actions = {
  // Called once on boot: the cookie is httpOnly, so the only way to know
  // whether there is a session is to ask the API.
  fetchSession: () => ({
    [RSAA]: {
      endpoint: `${entryPoint}/auth/me`,
      method: 'GET',
      types: [types.SESSION_REQUEST, success(types.SESSION_SUCCESS), types.SESSION_FAILURE],
    },
  }),

  login: (login, password) => ({
    [RSAA]: {
      endpoint: `${entryPoint}/auth/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login, password }),
      types: [types.LOGIN_REQUEST, success(types.LOGIN_SUCCESS), types.LOGIN_FAILURE],
    },
  }),

  logout: () => ({
    [RSAA]: {
      endpoint: `${entryPoint}/auth/logout`,
      method: 'POST',
      types: [types.LOGOUT_REQUEST, types.LOGOUT_SUCCESS, types.LOGOUT_FAILURE],
    },
  }),
}

export default actions
